import BaseComponent from "../BaseComponent";
import HorizontalLayout from "../layouts/HorizontalLayout";
import PropTypes from "prop-types";
import ButtonGroup from "../../../appl/view/components/buttons/ButtonGroup";
import InputDropDown from "../../../appl/view/components/inputFields/dropdown/InputDropDown";
import FrLogoSvg from "../images/FrLogoSvg";
import DeLogoSvg from "../images/DeLogoSvg";
import CM from "../../../appl/model/system/CM";
import LoaderLogo from "./LoaderLogo";
import shortid from "shortid";
import InputSearchDropDown from "../../../appl/view/components/inputFields/dropdown/InputSearchDropDown";
import ChangeAccount from "../../model/service/system/dto/ChangeAccount";
import ButtonTab from "../tabbar/ButtonTab";
import React, {createRef} from "react";
import Settings from "../../../appl/view/components/settings/Settings";
import SettingsItem from "../../../appl/view/components/settings/SettingsItem";
import Window from "../../../lib/components/window/Window";
import AccountPage from "../../../appl/view/components/account/AccountPage";
import Entity from "../../../appl/view/components/entity/Entity";
import DataSource from "../../model/service/dataSource/DataSource";
import {toast} from "react-toastify";
import TableButtonGroup from "../../../appl/view/components/entity/tableButtonGroup/TableButtonGroup";
import T from "../../../appl/model/system/text_translations/Translator";
import Button from "../../../appl/view/components/buttons/Button";
import MenuItem from "../../../appl/view/components/menu/MenuItem";
import DarkLightSwitch from "../../../appl/view/components/switch/DarkLightSwitch";
import {Help} from "@mui/icons-material";
import HelpWindow from "../../../appl/view/components/help/HelpWindow";
import {IconButton} from "@mui/material";
import BaseTab from '../../../appl/view/components/tabbar/BaseTab';
import Privilege from "../../model/types/Privilege";
import cner_config from "../../../cner.config";

class Header extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      status: CM.STATUS_IDLE
    }
    CM.get().addOnStatusChangeListeners((status) => this.onStatusChange(status));
    this.mainPanel = CM.get().getPanel();
  }

  componentDidMount() {
    super.componentDidMount();
    setTimeout(() => {
      this.sideBar = this.mainPanel.layoutRef.current.sideBarRef.current;
    }, 1);
  }

  async onStatusChange(status) {
    this.state.status = status;
    this.setState(this.state);
  }

  onThemeSwitchChange(e) {
    if (e.target.checked) {
      CM.get().setTheme(CM.STD_DARK);
    } else {
      CM.get().setTheme(CM.STD_LIGHT);
    }
  }

  onLanguageDropDownChange(e, id, option) {
    CM.get().setLanguage(option);
  }

  onAccountChange(e, id, option) {
    CM.get().doJsonAjax(CM.get().getServiceUrl('SystemService'), new ChangeAccount(option.id),
      function(responseUserContext) {
        if (responseUserContext.success) {
          window.location.href = '/cner';
        }
      });
  }

  onOpenAccount(e) {
    this.sideBar.refreshMenu();
    let tabId = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={T.label_account()}/>,
      <AccountPage ref={createRef()}/>, 'label_account');

    this.mainPanel.horizontalTabBarRef.current.addTabListener({
      id: tabId, hook: (id) => {
        if (id === tabId) {
          this.sideBar.refreshMenu();
        }
      }
    });
  }

  onOpenSettings(e) {
    this.sideBar.refreshMenu();

    let tabId = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={T.label_settings()}/>,
      <Settings ref={createRef()}/>, 'label_settings');
    this.mainPanel.horizontalTabBarRef.current.addTabListener({
      id: tabId, hook: (id) => {
        if (id === tabId) {
          this.sideBar.refreshMenu();
        }
      }
    });
  }

  createSettingsItem(dataSource, settingItems, title, image, self) {
    if (dataSource !== null) {
      settingItems.push(<SettingsItem title={title} img={<img src={image} className='p-8' alt={title}/>}>
        <Window><Entity headerButtons={<TableButtonGroup ref={createRef()} editable/>}
                        parent={self} dataSource={dataSource}/></Window></SettingsItem>);
    }
  }

  generateDataSource(response, onDoneCallback) {
    let dataSource = null;
    if (response.success) {
      dataSource = DataSource.generateDatasource(response.data.serviceDescription.entityDefs[0], null,
        (datasource, dto, dataSourceDtoProcessEvents) => {
          CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), dto, (response) => {
            dataSourceDtoProcessEvents.doResponse(response);
          });
        });
    } else {
      toast.error(response.message);
    }
    onDoneCallback(dataSource);
  }

  onOpenSystem(e) {
    this.sideBar.refreshMenu();
    let system = <Window>
      System
    </Window>

    let tabId = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={T.label_system()}/>, system,
      'label_system');

    this.mainPanel.horizontalTabBarRef.current.addTabListener({
      id: tabId, hook: (id) => {
        if (id === tabId) {
          this.sideBar.refreshMenu();
        }
      }
    });
  }

  createHeaderButtons() {
    let buttonsForAdmin = [];
    let userContext = CM.get().getUserContext();
    if (userContext) {
      if (userContext.isRootUser) {
        buttonsForAdmin.push(<Button key={shortid()} onClick={(e) => this.onOpenSettings(
          e)}>{T.label_settings()}</Button>);
        buttonsForAdmin.push(<Button key={shortid()} onClick={(e) => this.onOpenSystem(e)}>{T.label_system()}</Button>);
      }
      if (userContext.isRootUser || (userContext.privileges &&
        Privilege.checkPrivilegeIsAllowed(userContext.privileges, 'User\\EditUser', Privilege.ALLOW_EDIT))) {
        buttonsForAdmin.push(<Button key={shortid()} onClick={(e) => this.onOpenAccount(
          e)}>{T.label_account()}</Button>);
      }
    }
    return buttonsForAdmin;
  }

  getDefaultLang() {
    let defaultLang = CM.get().getLangauge();
    switch (defaultLang) {
      case CM.LANG_FR:
        return 'fr';
      default:
        return 'de';
    }
  }

  addHelpForm() {
    let tabId = CM.get().getPanel().horizontalTabBarRef.current.addTab(<BaseTab tabTitle={'Hilfe'}/>, <HelpWindow/>,
      'Hilfe-Fenster');
  }

  render() {
    let accounts;
    let selectedAccount;
    if (this.props.accounts !== undefined) {
      accounts = this.props.accounts.map((account) => {
        if (account.id === this.props.selectedAccount) {
          selectedAccount = {label: account.name, id: account.id};
        }
        return {label: account.name, id: account.id}
      });
    }

    let checked = CM.get().getTheme() === CM.STD_DARK;

    let buttonsForAdmin = this.createHeaderButtons();

    let defaultLang = this.getDefaultLang();

    return <HorizontalLayout className={"items-center justify-between text-cn-color-white h-full px-3 " +
      this.props.className}>
      <HorizontalLayout className="w-1/3">
        <a className="flex items-center" href="/cner">
          <LoaderLogo status={this.state.status}/>
          {/* TODO: peto, temporär für Video */}
          <h2 className='ml-1 mt-2'>{cner_config[CM.get().developer].cner_nav_logo_text}</h2>
        </a>
        <p className="text-sm font-cn-inter-light self-center pl-1">{this.props.version}</p>
      </HorizontalLayout>

      <HorizontalLayout className="justify-center w-1/3 hidden md:block">
        <ButtonGroup>
          {buttonsForAdmin}
        </ButtonGroup>
      </HorizontalLayout>

      <HorizontalLayout className="justify-end gap-5 w-1/3 items-center">
        <IconButton
          color='secondary' size='large'
          onClick={() => this.addHelpForm()}>
          <Help/>
        </IconButton>
        <InputDropDown size={'small'} width={200} onChange={(e, id, option) => this.onLanguageDropDownChange(e, id,
          option)} defaultValue={defaultLang}>
          <MenuItem value={'de'}>
            <div className='flex gap-2 items-center'><DeLogoSvg/>DE</div>
          </MenuItem>
          {/*<MenuItem value={'fr'}>*/}
          {/*  <div className='flex gap-2 items-center'><FrLogoSvg/>FR</div>*/}
          {/*</MenuItem>*/}
          {/*<MenuItem option={<ItLogoSvg/>}><ItLogoSvg/>IT</MenuItem>*/}
          {/*<MenuItem option={<EnLogoSvg/>}><EnLogoSvg/>EN</MenuItem>*/}
        </InputDropDown>

        <DarkLightSwitch onChange={(e) => this.onThemeSwitchChange(e)} checked={checked}/>

        {CM.get().getUserContext() !== null && CM.get().getUserContext().isRootUser &&
          <InputSearchDropDown size='small' key={shortid()} defaultValue={selectedAccount}
                               onChange={this.onAccountChange} disableClearable={true}>
            {accounts}
          </InputSearchDropDown>}
      </HorizontalLayout>
    </HorizontalLayout>
  }
}

Header.propTypes = {
  className: PropTypes.string,
  version: PropTypes.string,
  accounts: PropTypes.array.isRequired,
  selectedAccount: PropTypes.number
}
export default Header;

